import { render, staticRenderFns } from "./Lot.vue?vue&type=template&id=ec064e7c&"
import script from "./Lot.vue?vue&type=script&lang=js&"
export * from "./Lot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports